import React, { memo } from "react";

import makeStyles from "@material-ui/core/styles/makeStyles";
import InputBase from "@material-ui/core/InputBase";
import { Search as SearchIcon } from "@material-ui/icons";

import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "5px",
    borderRadius: "4px",
    alignItems: "center",
    display: "flex",
  },
  input: {
    flexGrow: 1,
    fontSize: "12px",
    lineHeight: "12px",
    letterSpacing: "-0.05px",
  },
  search: {
    position: "relative",
    borderStyle: "solid",
    borderColor: "#c4c4c4",
    borderRadius: theme.shape.borderRadius,
    border: "1px",
    backgroundColor: "#F5F7FA",
    "&:hover": {
      backgroundColor: "#F5F7FA",
    },
    width: "100%",
  },
  searchIcon: {
    padding: theme.spacing(0, 0),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    borderColor: "#000",
    width: '100%'
  },
  inputInput: {
    fontSize: "15px",
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
    width: "100%",
  },
}));

const SearchInput = (props) => {
  const { handleChange, placeholder } = props;

  const classes = useStyles();

  return (
    <div className={clsx(classes.search, classes.root)}>
      <div className={classes.searchIcon}>
        <SearchIcon />
      </div>
      <InputBase
        placeholder={placeholder}
        onChange={handleChange}
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}
      />
    </div>
  );
};

export default memo(SearchInput);
